import { Route, Routes } from 'react-router-dom';
import Master from "./pages/Mater";
import Paso1 from "./pages/Paso1";
import Paso2 from "./pages/Paso2";
import Paso3 from "./pages/Paso3";
import Paso4 from "./pages/Paso4";

const rootUrl = process.env.REACT_APP_API_ROOT;
const rootClie = process.env.REACT_APP_API_CLIENT;
const rootAuth = process.env.REACT_APP_API_AUTHORITY;
const rootRedi = process.env.REACT_APP_API_REDIRECT;
const rootScopes = process.env.REACT_APP_API_SCOPES;

const Conrutes = {
    Clie: `${rootClie}`,    
    rity: `${rootAuth}`,    
    redi: `${rootRedi}`,
    copes: `${rootScopes}`,
    fThread: `${rootUrl}/api/DatosEstudiante`    
};

const RouteContainer = ({ account })  => {
 return (
     <Master name = { account.name } username = { account.username }>
        <Routes>
          <Route path="/"      element={<Paso1 usr = { account.username }/>}></Route>
          <Route path="/paso1" element={<Paso1 usr = { account.username }/>}></Route>
          <Route path="/paso2" element={<Paso2 usr = { account.username }/>}></Route>
          <Route path="/paso3" element={<Paso3 usr = { account.username }/>}></Route>
          <Route path="/paso4" element={<Paso4 usr = { account.username }/>}></Route>
        </Routes>
     </Master>
 );
};

const { Clie, rity, redi,copes,fThread } = Conrutes;

export { Clie, rity, redi, copes, fThread, RouteContainer };